// extracted by mini-css-extract-plugin
export default {"root":"TitleBarWin98_root__8EZUl","iconWrapper":"TitleBarWin98_iconWrapper__2dEZi","title":"TitleBarWin98_title__3FSkO","closeButton":"TitleBarWin98_closeButton__r9D4Q"};